import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { QuicklinkModule } from 'ngx-quicklink';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { DesaparecidoGamListComponent } from './desaparecidos/desaparecido-gam-list/desaparecido-gam-list.component';
import { DesaparecidoGamFormComponent } from './desaparecidos/desaparecido-gam-form/desaparecido-gam-form.component';

const routes: VexRoutes = [
  {
    path: RouteConstant.ROUTE_GAM_DESAPARECIDOS.url,
    component: DesaparecidoGamListComponent
  },
  {
    path: `${RouteConstant.ROUTE_GAM_DESAPARECIDOS.url}/:actionType`,
    component: DesaparecidoGamFormComponent
  },
  {
    path: `${RouteConstant.ROUTE_GAM_DESAPARECIDOS.url}/:actionType/:id`,
    component: DesaparecidoGamFormComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class GamRoutingModule { }
